import React from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router";
import HomeSidebar from "./HomeSidebar";
import "./mobile-sidebar.style.scss";
import MobileNotification from "./MobileNotification";
export default function MobileSidebar({
  setContentInside,
  content,
  userDetails,
  type,
  updateState,
}) {
  const history = useHistory();
  const decideComponent = () => {
    switch (content) {
      case "home":
        return <HomeSidebar type={type} handleClick={handleClick} />;

      case "notify":
        return <MobileNotification setContentInside={setContentInside} />;

      default:
        break;
    }
  };
  const handleClick = (obj) => {
    switch (obj.id) {
      case "myProfile":
        history.push("/user/profile");
        break;
      case "logout":
        localStorage.clear();
        updateState("appliedJobs", []);
        updateState("savedJobs", []);
        updateState("userDetails", null);

        break;
      case "login":
        history.push("/login");
        break;
      case "saved-jobs":
        history.push("/user/list/saved-jobs");
        break;

      case "recommended-jobs":
        history.push("/user/list/recommended-jobs");
        break;
      case "applied-jobs":
        history.push("/user/list/applied-jobs");
        break;
      case "help":
        history.push("/help");
        break;
      case "notify":
        setContentInside("notify");

        break;
      case "tc":
        history.push("/terms-and-condition");

        break;
      case "policy":
        history.push("/privacy-policy");
        break;
      case "help":
        history.push("/help");
        break;

      default:
        break;
    }
    setContentInside("");
  };

  return ReactDOM.createPortal(
    <div
      onClick={() => setContentInside("")}
      aria-hidden="true"
      className={`mobile-sidebar-main ${!content ? "close-sidebar" : ""}`}
    >
      <div onClick={(e) => e.stopPropagation()} className="msm-wrapper">
        <div className className="msm-header">
          <img className="dp" height="20px" src={userDetails?.candidate_img} />
          <div>
            <h6>{userDetails?.candidate_full_name}</h6>
            <p>{userDetails?.candidate_email}</p>
          </div>
        </div>
        <section className className="msm-body">
          {decideComponent()}
        </section>
      </div>
    </div>,
    document.body
  );
}
